<template>
  <div class="button-theme-select">
    <label
      v-for="variation in themeVariations"
      :key="variation"
    >
      <input
        type="radio"
        class="module-options__theme-input"
        :checked="selectedThemeVariation === variation"
        :name="`module-options__theme-input--${moduleData.id}`"
        :value="variation"
        :aria-label="$t('Theme %(variation)s', { variation })"
        @change="changeThemeVariation(variation)"
      >
      <div
        class="module-options__theme-preview"
        :class="[
          `editor-theme__${type}--${variation}`,
          {
            'module-options__theme-preview--no-text': type === 'play-button',
          }
        ]"
        aria-hidden="true"
      />
    </label>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import {
  cloneDeep, first, get, set,
} from 'lodash-es';
import { UPDATE_MODULE } from '@/lib/constants/store';
import { themes } from '@/lib/constants/themes.json';
import {
  useEditorStore,
} from '@/stores';

export default {
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
    property: {
      type: String,
      default: 'options.theme.variation',
    },
    type: {
      type: String,
      default: 'button', // either 'button' or 'play-button'
    },
    variations: {
      type: Array,
      default: null,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'currentPage',
    ]),
    themeVariations() {
      if (this.variations) return this.variations;
      const themeId = this.currentPage?.options?.theme?.name;
      const colors = themes.find((theme) => theme.id === themeId)?.buttonColors;
      if (colors) return colors.map((c) => c.id);
      return [1, 2];
    },
    selectedThemeVariation() {
      return get(this.moduleData, this.property, first(this.themeVariations));
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      UPDATE_MODULE,
    ]),
    changeThemeVariation(variation) {
      const data = cloneDeep(this.moduleData);
      set(data, this.property, variation);
      this[UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
  },
};
</script>

<style lang="stylus">
.button-theme-select {
  display: flex;
}
</style>
